var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-fees-receipt"},[(_vm.receipt)?_c('FeeReceiptTable',{attrs:{"id":"fee-receipt-table","receipt":_vm.receipt,"copyName":"STUDENT COPY"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }